import { GlobalService } from '../services/GlobalService';

export const openGoogleMap = () => {
  const latitude = '22.8185';
  const longitude = '72.6146';
  const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
  window.open(googleMapsUrl, '_blank');
};

export const handleCall = () => {
  // check if mobile device
  const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  if (isMobile) {
    window.location.href = 'tel:+919106391065';
  }
};

export const sendMail = () => {
  const email = 'info@globalmanikchand.in';
  const subject = 'Inquiry';
  const body = 'Hello, I have a question...';

  const mailtoURL = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = mailtoURL;
};

export async function GetBusinessType() {
  const resp = await GlobalService.BusinessType();
  const respVal = resp.message;
  if (respVal) {
    const businessTypeOptions = respVal.map((type: any) => ({
      value: type.name,
      label: type.name,
    }));
    return businessTypeOptions;
  } else {
    return [];
  }
}

export async function GetCustomerGroup() {
  const resp = await GlobalService.CustomerGroup();
  const respVal = resp.message;
  if (respVal) {
    const customerGroupOptions = respVal.map((type: any) => ({
      value: type.name,
      label: type.name,
    }));
    return customerGroupOptions;
  } else {
    return [];
  }
}
